export default {
  state: {
    adminGitIgnoreTemplates: null,
    adminPipelineTemplatesList: [],
  },
  mutations: {
    setAdminGitIgnoreTemplates(state, payload) {
      state.adminGitIgnoreTemplates = { ...payload };
    },
    setAdminPipelineTemplatesList(state, payload) {
      state.pipelineTemplatesList = payload;
    },
  },
  actions: {
    setAdminGitIgnoreTemplates(state, payload) {
      state.commit('setAdminGitIgnoreTemplates', payload);
    },
    setAdminPipelineTemplatesList(state, payload) {
      state.commit('setAdminPipelineTemplatesList', payload);
    },
  },
  getters: {
    getAdminGitIgnoreTemplates(state) {
      return state.adminGitIgnoreTemplates;
    },
    getAdminPipelineTemplatesList(state) {
      return state.pipelineTemplatesList;
    },
  }
};
